import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { Logger } from './core/log';
import { ToastrModule } from 'ngx-toastr';
import { DataTablesModule } from 'angular-datatables';

import { HttpClientModule } from '@angular/common/http';
import { ServiceProvider } from './core/service/service.provider';
import { ServiceConfig } from './core/service/service.url.config';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AutocompleteLibModule } from 'angular-ng-autocomplete';

import { FusionChartsModule } from 'angular-fusioncharts';
import { ChartModule } from 'angular-highcharts';

// material
import { MaterialModule } from './material.module';
import { MatTabsModule} from '@angular/material/tabs';
import { AgmCoreModule } from '@agm/core';
import { AngularResizedEventModule } from 'angular-resize-event';

// Import FusionCharts library and chart modules*
import * as FusionCharts from 'fusioncharts';
import * as charts from 'fusioncharts/fusioncharts.charts';
import * as FusionTheme from 'fusioncharts/themes/fusioncharts.theme.fusion';

import { ShowHidePasswordModule } from 'ngx-show-hide-password';

// Pass the fusioncharts library and chart modules*
FusionChartsModule.fcRoot(FusionCharts, charts, FusionTheme);

import { LoginLayoutComponent } from './shared/components/layouts/login-layout/login-layout.component';
import { AdminLayoutComponent } from './shared/components/layouts/admin-layout/admin-layout.component';
import { LoginFooterComponent } from './shared/components/footer/login-footer/login-footer.component';
import { AdminFooterComponent } from './shared/components/footer/admin-footer/admin-footer.component';
import { NotfoundComponent } from './shared/components/notfound/notfound.component';

import { LoginComponent } from './modules/login/login.component';
import { ForgotpasswordComponent } from './modules/forgotpassword/forgotpassword.component';
import { RoleSelectComponent } from './modules/login-role-select/roleselect.component';
import { RoleSelectFormComponent } from './modules/login-role-select/form/roleselect-form.component';
import { LoginFormComponent } from './modules/login/form/loginform.component';
import { ForgotpasswordFormComponent } from './modules/forgotpassword/form/forgotpassword-form.component';
import { ProductselectComponent } from './modules/productselect/productselect.component';
import { ProductListComponent } from './modules/productselect/product-list/product-list.component';
import { TopMenuBarComponent } from './shared/components/menu/top-menu-bar/top-menu-bar.component';
import { SideMenuBarComponent } from './shared/components/menu/side-menu-bar/side-menu-bar.component';
import { BreadcrumbComponent } from './shared/components/breadcrumb/breadcrumb.component';
import { GroupedBarChartComponent } from './shared/fusion-charts/grouped-bar-chart/grouped-bar-chart.component';
import { SimpleBarChartComponent } from './shared/fusion-charts/simple-bar-chart/simple-bar-chart.component';
import { DonutChartComponent } from './shared/fusion-charts/donut-chart/donut-chart.component';
import { SimpleColumnChartComponent } from './shared/fusion-charts/simple-column-chart/simple-column-chart.component';
import { StackedColumnChartComponent } from './shared/fusion-charts/stacked-column-chart/stacked-column-chart.component';
import { StarckedBarsComponent } from './shared/fusion-charts/stacked-bars/starcked-bars.component';
import { LoaderComponent } from './shared/components/loader/loader.component';
import { DevicemanagerComponent } from './modules/devicemanager/devicemanager.component';
import { DevicemangerListComponent } from './modules/devicemanager/devicemanger-list/devicemanger-list.component';
import { DashboardComponent } from './modules/dashboard/dashboard.component';
import { PlatformSetupComponent } from './modules/platform-setup/platform-setup.component';
import { PaginationModule } from './shared/components/pagination/pagination.module';
import { SearchModule } from './shared/components/search/search.module';
import { StorageServiceModule } from 'ngx-webstorage-service';
import { LocalStorageService } from './shared/local-storage.service'
// import { SearchComponent } from './shared/components/search/search.component';


@NgModule({
  declarations: [
    AppComponent,
    LoginLayoutComponent,
    AdminLayoutComponent,
    LoginFooterComponent,
    AdminFooterComponent,
    NotfoundComponent,
    LoginComponent,
    ForgotpasswordComponent,
    RoleSelectComponent,
    RoleSelectFormComponent,
    LoginFormComponent,
    ForgotpasswordFormComponent,
    ProductselectComponent,
    ProductListComponent,
    TopMenuBarComponent,
    SideMenuBarComponent,
    BreadcrumbComponent,
    GroupedBarChartComponent,
    SimpleBarChartComponent,
    DonutChartComponent,
    SimpleColumnChartComponent,
    StackedColumnChartComponent,
    StarckedBarsComponent,
    LoaderComponent,
    DevicemanagerComponent,
    DevicemangerListComponent,
    DashboardComponent,
    PlatformSetupComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,
    ToastrModule.forRoot({
      timeOut: 3000,
      positionClass: 'toast-bottom-right',
      preventDuplicates: true,
      closeButton: true
    }),
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyB2G0R1SIMqnpuzGcLBfKWRuZzaYKSEtVU',
      libraries: ['places']
    }),
    NgbModule,
    FormsModule,
    ReactiveFormsModule,
    AutocompleteLibModule,
    FusionChartsModule,
    DataTablesModule,
    MaterialModule,  
    ChartModule,
    MatTabsModule,
    AngularResizedEventModule,
    ShowHidePasswordModule,
    PaginationModule,
    SearchModule,
    StorageServiceModule
  ],
  providers: [
    ServiceProvider,
    Logger,
    ServiceConfig,
    LocalStorageService
  ],
  bootstrap: [AppComponent],
  entryComponents: []
})
export class AppModule { }
